import React from "react";
import { LucideIcon } from "lucide-react";
import { Card, CardContent } from "components/UI/Card";
import ButtonPrimary from "shared/Button/ButtonPrimary";

interface EmptyStateProps {
    icon?: LucideIcon;
    title: string;
    message: string;
    buttonLabel?: string;
    onButtonClick?: () => void;
    buttonClassName?: string;
    containerClassName?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
    icon: Icon,
    title,
    message,
    buttonLabel,
    onButtonClick,
    buttonClassName = "",
    containerClassName = "",
}) => {
    return (
        <div
            className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex justify-center items-center min-h-[calc(100vh-100px)] ${containerClassName}`}
        >
            <Card className="w-full max-w-md text-center border-gray-200 bg-gray-50">
                <CardContent className="p-8">
                    {Icon && (
                        <div className="flex justify-center mb-4">
                            <Icon className="h-12 w-12 text-gray-400" />
                        </div>
                    )}
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">{title}</h2>
                    <p className="text-gray-600 mb-6">{message}</p>
                    {buttonLabel && onButtonClick && (
                        <ButtonPrimary
                            onClick={onButtonClick}
                            className={`w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg transition-all duration-300 ${buttonClassName}`}
                        >
                            {buttonLabel}
                        </ButtonPrimary>
                    )}
                </CardContent>
            </Card>
        </div>
    );
};

export default EmptyState;
